import styled from "styled-components";
export const StyledCheckboxArea = styled.div`
  &.checkbox-area {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 0.4rem;

    .checkbox-area-label {
      align-self: stretch;
      color: var(--text-gray-strong);
      display: flex;
      gap: 0.4rem;

      /* label/label-medium-400 */
      font: var(--label-medium-400);
    }
    .required {
      color: var(--sys-red-1);

      /* label/label-medium-400 */
      font: var(--label-medium-400);
    }

    .checkbox-area-content {
      width: calc(100% - 2.4rem);
      max-height: 8rem;
      overflow: auto;
      display: flex;
      padding: 0.9rem 1.2rem;
      justify-content: start;
      /* align-items: center; */
      /* align-content: center; */
      gap: 1.6rem;
      /* align-self: stretch; */
      flex-wrap: wrap;
      border-radius: 0.4rem;
      border: 0.1rem solid var(--bg-gray-2);
      background: var(--bg-gray-normal);

      /* &.bg-gray {
        background: var(--bg-gray-0);
    } */
    }
  }
`;
